import {Hotkey, IconButton} from '@wandb/components';
import React from 'react';

export const ToggleMinimizeRunSelectorButton = ({
  variant,
  toMinimize,
  onToggle,
}: {
  variant: 'secondary' | 'primary' | 'destructive' | 'ghost';
  toMinimize: boolean;
  onToggle: () => void;
}) => {
  return (
    <IconButton
      aria-label={toMinimize ? 'Hide runs sidebar' : 'Reveal runs sidebar'}
      data-dd-action-name="Runs sidebar toggle"
      icon={toMinimize ? 'expand-left' : 'expand-right'}
      variant={variant}
      onPress={onToggle}
      tooltip={{
        children: (
          <>
            {toMinimize ? 'Hide sidebar' : 'Reveal runs sidebar'}
            <Hotkey
              ml={4}
              name="Toggle minimize run selector"
              keys={['Primary', 'Period']}
            />
          </>
        ),
      }}
    />
  );
};
